import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Demo from '@/views/index/index.vue'
import Login from '@/views/login/index.vue'
/*
* checkAuth:检查授权
* */
const routes = [
  {
    path: '/',
    name: 'index',
    meta:{checkAuth:true},
    component: Demo
  },
  {
    path: '/index',
    name: 'index2',
    meta:{checkAuth:true},
    component: Demo
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 强制登录：没登录的用户只能待在 /login，其他页面一律踢到登录页
router.beforeEach((to, from, next) => {
  const logged = !!localStorage.getItem('userInfo')
  if (to.path === '/login') {
    // 已登录的用户不再看登录
    if (logged) {
      next('/')
    } else {
      next()
    }
  } else if (!logged) {
    // 记住用户原本想去的地址，登录成功后跳回去
    next({path: '/login', query: {redirect: to.fullPath}})
  } else {
    next()
  }
})

export default router